export function formatRootGraphQLErrorMessage(message: string) {
  // Remove "Trace ID: ..." from the message for display
  const index = message.indexOf('Trace ID:');
  if (index !== -1) {
    return message.slice(0, index);
  }
  return message;
}
